// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Artwork_imageContainer__2bk3u","image":"Artwork_image__3GCwY","show":"Artwork_show__YrORY"};